import React, { useImperativeHandle } from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';
import IndicatorBottomButtons from '../IndicatorDetails/IndicatorBottomButtons';
import { BudgeComponentProps, BudgetSubmitReference } from './utils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import ShowGuidanceText from '../Review/ReportCustomQuestionType/ShowGuidanceText';

const tooltip = <></>;

const StyledDiv = styled.div`
  text-align: center;
  .question-text {
    max-width: 500px;
    margin-top: 48px;
    margin-left: auto;
    margin-right: auto;
  }
  .sub-heading {
    max-width: 566px;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  ul {
    display: inline-flex;
    flex-direction: column;
    text-align: left;
  }
`;

const answer = 'Yes, prepare budget';
const BudgetIntro = React.forwardRef<
  BudgetSubmitReference,
  BudgeComponentProps
>(({ hideBottomBar, guidanceText, onNext, onPrevious }, forwardRef) => {
  const handleNext = () => onNext(answer);

  useImperativeHandle(forwardRef, () => ({
    error: () => undefined,
    handleSubmit: () => answer,
  }));

  return (
    <StyledDiv>
      <ShowGuidanceText
        sectionId="budget"
        questionId={80001}
        guidanceText={guidanceText}
      />
      <TrueImpactText variant="heading-page" className="question-text">
        You’re in the home stretch! We just have a few questions about the
        annual budget for your program.
      </TrueImpactText>
      <TrueImpactText className="sub-heading">
        We’ll provide a few tools to help you calculate and complete this last
        section, but if you have your numbers handy, it’ll help you breeze right
        through it.
      </TrueImpactText>
      <div className="sub-heading">
        <TrueImpactText variant="body-bold">
          We will be asking about:
        </TrueImpactText>
        <ul>
          <li>Direct Costs</li>
          <li>Overhead</li>
          <li>In-kind Donations</li>
        </ul>
      </div>
      {!hideBottomBar && (
        <IndicatorBottomButtons
          requestState="init"
          previousButtonText="Previous Section"
          nextButtonText="Let’s go!"
          onNext={handleNext}
          onPrevious={onPrevious}
        />
      )}
    </StyledDiv>
  );
});

export default BudgetIntro;
